const initialState = {
  user: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'DOMAIN/USER/DATA': {
      return {
        ...state,
        user: action.user,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/domain/user.js